import React from "react";
import { Link } from "react-router-dom";
import Loader from "@pillvery/components/utility/loader";

export default function ValueCard({
  label,
  value,
  detailsPath,
  bgColorClass,
  description,
  date,
  cardWidth = 3,
  bgColor,
  hasDetailsBtn = true,
  displayIcon = true,
  valueStyle = {},
  placeholder,
  loading = false,
  loaderBorderColor = "#29c0b1",
  value2,
  label2,
  placeholder2,
}) {
  const btnClass = bgColorClass ? "btn-outline-light" : "btn-outline-info";

  // console.log("laoding")
  return (
    <div
      className={
        "col-12 col-sm-6 col-md-" + cardWidth + " grid-margin stretch-card"
      }
    >
      <div
        className={"card " + bgColorClass}
        style={{
          backgroundColor: bgColor,
          color: "#ffffff !important",
          minHeight: "140px",
        }}
      >
        <div className="card-body" style={{ color: "#ffffff" }}>
          <div className="d-flex align-items-center" style={{ height: "40px" }}>
            {displayIcon ? (
              <div className="icon mb-0 mb-md-2 mb-xl-0 mr-2">
                <i className="mdi mdi-star-circle"></i>
              </div>
            ) : null}
            <div className="d-flex flex-1 align-items-center justify-content-between ">
              <p className="font-weight-medium mb-0 font-weight-bold">
                {label}
              </p>
              {!!label2 && (
                <p className="font-weight-medium mb-0 font-weight-bold">
                  {label2}
                </p>
              )}
            </div>
          </div>
          <div className="d-flex flex-1 align-items-center justify-content-between ">
            <p className="font-weight-light mb-0" style={{ fontSize: 10 }}>
              {placeholder}
            </p>
            {!!placeholder2 && (
              <p className="font-weight-light mb-0" style={{ fontSize: 10 }}>
                {placeholder2}
              </p>
            )}
          </div>
          <div
            className=" align-items-center flex-wrap my-auto"
            style={displayIcon ? { textAlign: "center" } : null}
          >
            {loading ? (
              <Loader color={loaderBorderColor} />
            ) : value2 ? (
              <div className="d-flex flex-1 align-items-center justify-content-between ">
                <h2
                  className="font-weight-bold mb-0 mr-2 mt-4 col-"
                  style={{ ...valueStyle, color: "#ffffff" }}
                >
                  {value}
                </h2>
                <h2
                  className="font-weight-bold mb-0 mr-2 mt-4 col-"
                  style={{ ...valueStyle, color: "#ffffff" }}
                >
                  {value2}
                </h2>
              </div>
            ) : (
              <h2
                className="font-weight-bold mb-0 mr-2 mt-4 col-"
                style={{ ...valueStyle, color: "#ffffff" }}
              >
                {value}
              </h2>
            )}
          </div>
        </div>
        {!loading ? (
          <div className="card-footer" style={{ border: "none" }}>
            <>
              {description ? (
                <div className="text-left">
                  {description}
                  <br />
                  <span className="font-weight-bold mb">{date}</span>
                </div>
              ) : null}
              {hasDetailsBtn ? (
                <div className="text-right">
                  <Link
                    to={detailsPath}
                    className={"btn btn-fw " + btnClass}
                    style={{ fontSize: 13, padding: 6, width: 65 }}
                  >
                    Details
                  </Link>
                </div>
              ) : null}
            </>
          </div>
        ) : null}
      </div>
    </div>
  );
}
